export default __webpack_public_path__ + "static/to-area-51-48fd0da7bc59320fd06d0cf5f0d98993.jpg";